import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateComplaintStatus, type UpdateStatusRequest, type Complaint } from '../api';

/**
 * Hook for updating complaint status (vendor only)
 * @param complaintId - The complaint ID to update
 */
export function useUpdateComplaintStatus(complaintId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UpdateStatusRequest): Promise<{ status: boolean; data: Complaint }> =>
      updateComplaintStatus(complaintId, data),
    onSuccess: () => {
      // Invalidate both the list and detail queries
      queryClient.invalidateQueries({ queryKey: ['complaints'] });
      queryClient.invalidateQueries({ queryKey: ['complaint', complaintId] });
    },
  });
}
